/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import 'twin.macro';

import React, { useState } from 'react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import tw from 'twin.macro';

import CardIconGreen from '@/assets/images/icons/CardIconGreen';
import CartIcon from '@/assets/images/icons/CartIcon';
import ChartIcon from '@/assets/images/icons/ChartIcon';
import DamageIcon from '@/assets/images/icons/DamageIcon';
import MoneyExchangeIcon from '@/assets/images/icons/MoneyExchangeIcon';
import MoneyIcon from '@/assets/images/icons/MoneyIcon';
import MoneyMoveIcon from '@/assets/images/icons/MoneyMoveIcon';
import SaleIcon from '@/assets/images/icons/SaleIcon';
import SecurityIcon from '@/assets/images/icons/SecurityIcon';
import SmsIcon from '@/assets/images/icons/SmsIcon';
import { Button, Modal, SubTitle, Title } from '@/components';
import CardBenefitBlock from '@/components/card-benefit-block/card-benefit-block';

function DepositBenefitsContainer({ activeTab }) {
  const { t } = useTranslation();
  const [open, setOpen] = useState();
  const cardBenefits = useMemo(
    () => [
      [
        {
          icon: <CardIconGreen />,
          title: t('info_landing.card_types.card_1.title'),
          caption: t('info_landing.card_types.card_1.subtitle')
        },
        {
          icon: <MoneyExchangeIcon />,
          title: t('info_landing.card_types.card_2.title'),
          caption: t('info_landing.card_types.card_2.subtitle')
        },
        {
          icon: <MoneyMoveIcon />,
          title: t('info_landing.card_types.card_3.title'),
          caption: t('info_landing.card_types.card_3.subtitle')
        },
        {
          icon: <SecurityIcon />,
          title: t('info_landing.card_types.card_4.title'),
          caption: (
            <span>
              государством на сумму до 20 млн тенге.{' '}
              <a tw='underline cursor-pointer' onClick={() => setOpen(true)}>
                Подробнее
              </a>
            </span>
          )
        },
        {
          icon: <CartIcon />,
          title: t('info_landing.card_types.card_5.title'),
          caption: t('info_landing.card_types.card_5.subtitle')
        },
        {
          icon: <SaleIcon />,
          title: t('info_landing.card_types.card_6.title'),
          caption: t('info_landing.card_types.card_6.subtitle')
        }
      ],
      [
        { icon: <CardIconGreen />, title: 'Выпуск карты онлайн', caption: 'за 5 минут без посредников' },
        { icon: <MoneyExchangeIcon />, title: 'Конвертации и переводы', caption: 'внутри банка без комиссий' },

        {
          icon: <ChartIcon />,
          title: 'Удобно инвестировать',
          caption: 'Карта привязана к счёту во Freedom Finance Global PLC'
        },
        {
          icon: <MoneyMoveIcon />,
          title: 'Свобода движения денег',
          caption: 'Доступны разные способы пополнения и вывода денег'
        },
        { icon: <CartIcon />, title: 'Легко платить', caption: 'по всему миру и в интернете' },
        { icon: <SaleIcon />, title: 'Вознаграждение на остаток', caption: '3% годовых в долларах' }
      ],
      [
        { icon: <CardIconGreen />, title: 'Выпуск цифровой карты онлайн', caption: 'за 5 минут и без посредников' },
        {
          icon: <SecurityIcon />,
          title: 'Безопасность ',
          caption: 'Есть CVC и 3D-secure, работает в электронных кошельках'
        },

        {
          icon: <SmsIcon />,
          title: 'Для открытия не нужны документы',
          caption: 'Достаточно номера телефона'
        },
        {
          icon: <MoneyIcon />,
          title: 'Фиксированный номинал',
          caption: '50, 100 и 200 долларов'
        },
        { icon: <CartIcon />, title: 'Легко платить', caption: 'по всему миру и в интернете' },
        { icon: <DamageIcon />, title: 'Ограничения', caption: 'Пополнение или снятие денег с карты невозможны' }
      ]
    ],
    []
  );
  const navigate = useNavigate();
  const handleNavigate = () => {
    switch (activeTab) {
      case 1:
        navigate('/deposit-card-info');
        break;
      case 2:
        navigate('/invest-card-info');
        break;
      case 3:
        navigate('/prepaid-card-info');
        break;
      default:
        break;
    }
  };
  return (
    <div
      tw='xl:p-9 md:p-5 sm:p-5 sm:border sm:border-[#2A8640] relative'
      css={[
        activeTab === 1 && tw`rounded-r-2xl rounded-bl-2xl `,
        activeTab === 2 && tw`rounded-2xl `,
        activeTab === 3 && tw`rounded-l-2xl rounded-br-2xl`
      ]}
    >
      {/* {!isMobile && (
        <span tw='absolute w-[15%] border-t h-[7%] border-r border-[#2A8640] rounded-tr-2xl bottom-[93.15%] sm:left-[85.11%] md:left-[85.11%] lg:left-[85.13%] xl:left-[85.13%] 2xl:left-[85.13%]'></span>
      )} */}
      <div tw='flex sm:flex-row flex-col gap-5 w-full'>
        <div tw='flex flex-col gap-5'>
          <CardBenefitBlock
            icon={cardBenefits[activeTab - 1][0].icon}
            title={cardBenefits[activeTab - 1][0].title}
            caption={cardBenefits[activeTab - 1][0].caption}
          />
          <CardBenefitBlock
            icon={cardBenefits[activeTab - 1][1].icon}
            title={cardBenefits[activeTab - 1][1].title}
            caption={cardBenefits[activeTab - 1][1].caption}
          />
        </div>
        <div tw='flex flex-col gap-5'>
          <CardBenefitBlock
            icon={cardBenefits[activeTab - 1][2].icon}
            title={cardBenefits[activeTab - 1][2].title}
            caption={cardBenefits[activeTab - 1][2].caption}
          />
          <CardBenefitBlock
            icon={cardBenefits[activeTab - 1][3].icon}
            title={cardBenefits[activeTab - 1][3].title}
            caption={cardBenefits[activeTab - 1][3].caption}
          />
        </div>
        <div tw='flex flex-col gap-5'>
          <CardBenefitBlock
            icon={cardBenefits[activeTab - 1][4].icon}
            title={cardBenefits[activeTab - 1][4].title}
            caption={cardBenefits[activeTab - 1][4].caption}
          />
          <CardBenefitBlock
            icon={cardBenefits[activeTab - 1][5].icon}
            title={cardBenefits[activeTab - 1][5].title}
            caption={cardBenefits[activeTab - 1][5].caption}
          />
        </div>
      </div>
      <div tw='text-center mt-5'>
        <Button variant={'shadow'} twStyle={tw` mx-auto w-1/3`} onClick={handleNavigate}>
          {t('info_landing.card_types.button')}
        </Button>
      </div>
      <Modal setOpen={setOpen} open={open} twStyle={tw`rounded-2xl sm:max-w-[800px] max-w-[95vw] flex flex-col `}>
        <Title twStyle={tw`sm:mb-10 mb-5`} text={'Государственная защита счетов и вкладов'} variant={'bold'} />
        <SubTitle
          twStyle={tw`sm:text-s18 text-s14`}
          text={
            <span>
              Счета и вклады иностранных граждан, открытые в АО “Фридом Банк Казахстан”, защищены Казахстанским Фондом
              Гарантирования Депозитов. <br />
              Гарантия распространяется на вклады, вознаграждения по ним, деньги на текущих счетах и платежных
              карточках.
              <br />
              Максимальная сумма гарантии: <br />
              <ul>
                <li>20 миллионов тенге по сберегательным вкладам в тенге;</li>
                <li>10 миллионов тенге по карточкам, счетам и другим депозитам в тенге;</li>
                <li>
                  5 миллионов тенге по карточкам, счетам и депозитам в иностранной валюте (в эквиваленте по курсу,
                  установленному на дату лишения банка-участника лицензии).
                </li>
              </ul>
              <br />
              Если в одном банке-участнике размещено несколько депозитов, различных по видам и валюте, то гарантируется
              совокупный остаток суммы по всем депозитам, но не более максимальной суммы гарантийного возмещения – 20
              миллионов тенге, с учетом пределов по каждому виду депозита.
              <br />
              Подробнее —
              <a
                href='https://kdif.kz/?ysclid=le4j2sqp9w439792884'
                target='_blank'
                rel='noreferrer'
                tw='text-[#70FF6E] '
                onClick={() => window.open('https://kdif.kz/?ysclid=le4j2sqp9w439792884', '_blank')}
              >
                на сайте КФГД.
              </a>
            </span>
          }
        />
        <Button
          variant='ghost'
          twStyle={tw`rounded-md sm:max-w-[150px] max-w-[] sm:mt-10 mt-5`}
          onClick={() => setOpen(false)}
        >
          Закрыть
        </Button>
      </Modal>
    </div>
  );
}

export default DepositBenefitsContainer;
